import React from 'react';
import { Form } from 'antd';
import { SessionForm } from '@components/Clinicians/session-form';
import WrappedTipTapEditor from '@components/Clinicians/WrappedTipTapEditor';
import { useSessionFormState } from '@hooks/useSessionFormState';

const NoteEditor = ({
  field,
  placeholder,
  readOnly,
  isLimitedNumberCharacters = true,
  onChange,
  ariaLabel
}: {
  field: keyof SessionForm;
  placeholder: string;
  readOnly: boolean;
  isLimitedNumberCharacters?: boolean;
  onChange: ({
    field,
    value,
    skipSanitisation
  }: {
    field: keyof SessionForm;
    value: string;
    skipSanitisation?: boolean;
  }) => void;
  ariaLabel?: string;
}) => {
  const [noteValue] = useSessionFormState(field);

  return (
    <Form.Item name={field}>
      <WrappedTipTapEditor
        key={`${field}-editor`}
        ariaLabel={ariaLabel}
        id={field}
        onChange={onChange}
        placeholder={placeholder}
        value={noteValue}
        readOnly={readOnly}
      />
    </Form.Item>
  );
};

export default NoteEditor;
